import Image from 'next/image'
import classNames from 'classnames'
import { useTranslation } from '@mc/i18n'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import Link from 'components/Link'
import CertificatesLogo from 'pages/certificates/assets/cert-shield-black.svg'
import { TrackClick } from 'pages/certificates/tracking'
import classes from './BaseNavigation.module.scss'

export interface BaseNavigationProps {
  companyLogo?: {
    url: string
    altText?: string
  }
  className?: string
  rightContent?: React.ReactNode
  logoHref?: string
  showLogo?: boolean
  trackingData?: Record<string, unknown>
  preEnrolled?: boolean
  enrolled?: boolean
  transparent?: boolean
  light?: boolean
}

export const BaseNavigation = ({
  companyLogo,
  rightContent,
  logoHref,
  preEnrolled = false,
  enrolled = false,
  transparent = false,
  light = false,
  className = '',
}: BaseNavigationProps) => {
  const { t } = useTranslation('@mc/next')
  const getDefaultLogoHref = () => logoHref ?? paths.root

  const navClassName = classNames(classes.dropdownMenu, {
    'top-0 min-h-[var(--mc-scale-10)] z-[1030] bg-c-base-600': preEnrolled,
    'border-b border-dashed border-c-beige-700': enrolled,
    'fixed md:relative w-full bg-transparent md:bg-transparent shadow-none':
      transparent,
    'bg-c-base-100': light,
    'mc-page__header': enrolled,
    [className]: className,
  })

  return (
    <Nav contained={false} className={navClassName} background='transparent'>
      <Nav.Left className='h-full'>
        <div className='flex items-center h-full'>
          {companyLogo ? (
            <TrackClick
              event='certificateNavigationClicked'
              action='MC Logo'
              level='primary'
              location='nav bar'
              href={getDefaultLogoHref()}
            >
              <Link
                href={getDefaultLogoHref()}
                aria-label='MasterClass Certificates'
                className='h-full'
              >
                <Image
                  src={companyLogo.url}
                  alt={companyLogo.altText || t('nav.companyLogo')}
                  width={200}
                  height={60}
                  className='h-full w-auto'
                  sizes='(max-width: 768px) 150px, 200px'
                  priority
                />
              </Link>
            </TrackClick>
          ) : (
            <TrackClick
              event='certificateNavigationClicked'
              action='MC Logo'
              level='primary'
              location='nav bar'
              href={getDefaultLogoHref()}
            >
              <Link
                href={getDefaultLogoHref()}
                aria-label='MasterClass Certificates'
              >
                <CertificatesLogo />
              </Link>
            </TrackClick>
          )}
        </div>
      </Nav.Left>

      <Nav.Right>{rightContent}</Nav.Right>
    </Nav>
  )
}
